import React, { useState, useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
/* eslint-disable import/named */
import { MultiValue } from 'react-select';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import MultiSelectSortable, {
  ReactSelectOption,
} from '../Selects/SortableSelect';

export interface BatteryMultiSelectorProps {
  readOnly?: boolean;
  selectedBattery?: ReactSelectOption[];
  onChange?: (options: MultiValue<ReactSelectOption>) => void;
}

export default (props: BatteryMultiSelectorProps) => {
  const spd = useSpdCore();
  const [batteries, setBatteries] = useState<ReactSelectOption[]>([]);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let mounted = true;
    spd.batteries
      .getAll()
      .then(t => {
        if (mounted) {
          const result = t.map(
            a =>
              ({
                value: a.id,
                label: a.name,
              }) as ReactSelectOption,
          );
          setBatteries(result);
          setReady(true);
        }
      })
      .catch(error =>
        console.log(`Wystąpił problem z pobraniem baterii testów. ${error}`),
      );

    return () => {
      mounted = false;
    };
  }, [spd.batteries]);

  return ready ? (
    <MultiSelectSortable
      options={batteries}
      defaultValue={props.selectedBattery || []}
      onChange={options => props.onChange && props.onChange(options)}
    />
  ) : (
    <Skeleton />
  );
};
